import React from "react";
import { Container, ContainerItem, Input } from "../../components";
import { capitalizeString } from "../../utils/utils";

const units = {
  steps: "steps per day",
  active_minutes: "minutes per day",
  distance: "miles per day",
  sleep: "hours per day",
  pelotonkjs: "KJs per day",
  gym_visit: "gym check-in(s) per day",
  referral: "referrals per day",
};

const Metric = ({ metric, index, isDoubleMetric }) => {
  return (
    <Container padding="0" column width="345px">
      <ContainerItem padding="0 0 8px 0">
        <Input
          readOnly
          label={isDoubleMetric ? `Metric ${index + 1}` : "Metric"}
          value={metric.name}
        />
      </ContainerItem>
      <ContainerItem padding="8px 0">
        <Input
          readOnly
          label="Is there a per day goal? "
          value={capitalizeString(metric.hasPerDayGoal.toString())}
        />
      </ContainerItem>
      {metric.hasPerDayGoal ? (
        <>
          <ContainerItem padding="8px 0">
            <Input
              readOnly
              label="Per day goal "
              value={`${metric.perDayGoal} ${units[metric.name.toLowerCase()]}`}
            />
          </ContainerItem>
          <ContainerItem padding="8px 0">
            <Input
              readOnly
              label="Goal Description "
              value={metric.goalDescription}
            />
          </ContainerItem>
        </>
      ) : null}
      <ContainerItem padding="8px 0">
        <Input
          readOnly
          label="Is there a prize? "
          value={capitalizeString(metric.hasPrize.toString())}
        />
      </ContainerItem>
      {metric.hasPrize ? (
        <ContainerItem padding="8px 0">
          <Input
            readOnly
            label="Prize description "
            value={metric.prizeDescription}
          />
        </ContainerItem>
      ) : null}
    </Container>
  );
};

export default Metric;
